import React, { useState } from 'react';
import Image from 'next/legacy/image';

type ExpertProps = {
  imageUrl: string;
  imageAlt: string;
  firstName: string;
  lastName: string;
  company: string;
  job?: string;
  email?: string;
  phone?: string;
  textClassName?: string;
  expertNameFonts?: string;
  containerClassName?: string;
  companyClassName?: string;
};

const Expert: React.FC<ExpertProps> = ({
  imageUrl,
  imageAlt,
  firstName,
  lastName,
  company,
  job,
  email,
  phone,
  textClassName,
  expertNameFonts,
  containerClassName,
  companyClassName,
}) => {
  const [emailCopied, setEmailCopied] = useState(false);

  const handleCopyEmail = () => {
    if (!email) return;
    navigator.clipboard.writeText(email).then(() => {
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000);
    });
  };

  return (
    <>
      <div
        className={`${containerClassName} relative w-[84px] h-[84px] md:mt-0 mr-[15px] md:mr-6 text-16-26-0.3 lg:mr-10 lg:w-28 lg:h-28`}
      >
        <Image
          className="object-contain w-full h-full"
          src={imageUrl}
          alt={imageAlt || ''}
          loading="eager"
          layout="fill"
          blurDataURL={imageUrl}
          placeholder="blur"
          priority
        />
      </div>
      <div className={`flex flex-col ${textClassName}`}>
        <div
          className={`mb-[12px] md:mb-2 uppercase font-sohneBreitHalbfett text-14-18-0.3 ${expertNameFonts}`}
        >
          {firstName} {lastName}
        </div>
        <span className="text-14-21-0.3 md:text-13-21-0.3 lg:text-16-21-0.3">
          {job}
        </span>
        <span
          className={`text-14-21-0.3 md:text-13-21-0.3 lg:text-16-21-0.3 ${companyClassName}`}
        >
          {company}
        </span>
        {(phone || email) && (
          <div className="mt-4">
            {phone && (
              <a
                href={`tel:${phone}`}
                className="block text-14-21-0.3 md:text-13-21-0.3 lg:text-16-21-0.3 mb-1"
              >
                {phone}
              </a>
            )}
            {email && (
              <div className="flex items-center gap-2 flex-wrap">
                <a
                  href={`mailto:${email}`}
                  className="font-sohneKraftig text-14-21-0.3 md:text-13-21-0.3 lg:text-16-21-0.3 border-b-2 border-gold-underline whitespace-nowrap"
                >
                  Email {firstName}
                </a>
                <button
                  type="button"
                  onClick={handleCopyEmail}
                  className="flex-shrink-0"
                  aria-label="Copy email address"
                >
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    src="/images/copy.svg"
                    alt=""
                    className="w-6 h-6 md:w-5 md:h-5"
                  />
                </button>
                {emailCopied && (
                  <span className="text-13-21-0.3 text-gray-500 whitespace-nowrap">
                    Email copied
                  </span>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Expert;
